import React from "react";
import { Outlet } from "react-router-dom";
import { motion } from "framer-motion";
import { Box } from "@mui/system";
import Dashboard from "./wrappers/DashboardWrapper";
import "../style/admin.css"
import useBodyClasses from "../hooks/useBodyClasses";

function App() {
  useBodyClasses(['admin']);
  return (
    <Dashboard>
      <Box component={motion.main}>
        <Outlet />
      </Box>
    </Dashboard>
  );
}
export default App;